import { NextCustomImage } from 'components/Image';
import { PlayIcon } from 'icons/PlayIcon';
import { secondsToMinAndSeconds } from 'utils/dateUtils';
import { Video } from 'interfaces/content/Media';
import BLURRED_GRAY_PLACEHOLDER from 'lib/mockData/Image/placeholderUrl';
import { COMMON_TEST_IDS } from 'constants/testsIds/common';
import { PlayButton, Timer, TimerWrapper, VideoWrapper } from './VideoPreviewStyles';

const VideoPreview = ({ video }: { video: Video }) => {
  const { name, originalImage, duration } = video;
  return (
    <VideoWrapper>
      <NextCustomImage
        src={originalImage || BLURRED_GRAY_PLACEHOLDER}
        alt={name}
        width='735'
        height='413'
        data-cy={COMMON_TEST_IDS.VIDEO_PREVIEW}
      />
      <PlayButton>
        <PlayIcon />
      </PlayButton>
      <TimerWrapper>
        <Timer>{secondsToMinAndSeconds(duration.value)}</Timer>
      </TimerWrapper>
    </VideoWrapper>
  );
};

export default VideoPreview;
